import { canv } from '@/canv/global.js'

export class shapeArrowRight {

    constructor() {

    }


    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width * 2/3 - 2 * horizontalPadding;
        var allowedHeight = height/2 - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width * 3/4 / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;


        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y + height / 4);
        canv.ctx.lineTo(x + width * 2/3, y + height / 4);
        canv.ctx.lineTo(x + width * 2/3, y);
        canv.ctx.lineTo(x + width, y + height / 2);
        canv.ctx.lineTo(x + width * 2/3, y + height);
        canv.ctx.lineTo(x + width * 2/3, y + height * 3/4);
        canv.ctx.lineTo(x, y + height * 3/4);
        canv.ctx.lineTo(x, y + height / 4);
        canv.ctx.closePath();
    }

    getAvatar(color) {
        return `
        <svg width="70" height="78" viewBox="0 0 70 78" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M30.625 1.44136V16.3333C30.625 16.8856 30.1773 17.3333 29.625 17.3333H1C0.447716 17.3333 0 17.781 0 18.3333V59.6667C0 60.2189 0.447716 60.6667 1 60.6667H29.625C30.1773 60.6667 30.625 61.1144 30.625 61.6667V76.5586C30.625 77.4533 31.71 77.8978 32.3377 77.2602L69.3094 39.7015C69.6926 39.3123 69.6926 38.6877 69.3094 38.2985L32.3377 0.739837C31.71 0.102223 30.625 0.546651 30.625 1.44136Z"
        fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.5 2.22684V4.5C11.5 5.05228 11.0523 5.5 10.5 5.5H2C1.44772 5.5 1 5.94772 1 6.5V17.5C1 18.0523 1.44772 18.5 2 18.5H10.5C11.0523 18.5 11.5 18.9477 11.5 19.5V21.7732C11.5 22.636 12.5195 23.0938 13.1644 22.5206L24.1592 12.7474C24.6067 12.3496 24.6067 11.6504 24.1592 11.2526L13.1644 1.47943C12.5195 0.906189 11.5 1.364 11.5 2.22684Z" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
